// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ko","show":"kp","dark":"kq","top":"kr","bottom":"ks","left":"kt","right":"ku"};